import { AppService } from '@services/app/app.service';
import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { ThemeViews } from '@core/models';

/**
 * determina la visualizzazione del componente se il codice della view risulta attivo
 */
@Directive({ selector: '[appIfView]' })
export class IfViewDirective {
  private hasView = false;

  private _code: ThemeViews;

  private _opposite: boolean;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private appService: AppService
  ) {}

  @Input() set appIfView(code: ThemeViews) {
    this._code = code;
    this.toggleView();
  }

  /**
   * se true, l'elemento viene nascosto se la view risulta attiva
   */
  @Input() set appIfViewOpposite(value: boolean) {
    this._opposite = value;
    this.toggleView();
  }

  private toggleView(): void {
    if (this.isToShow() && !this.hasView) {
      this.showElement();
    } else if (!this.isToShow() && this.hasView) {
      this.hideElement();
    }
  }

  private isToShow(): boolean {
    const active = this.appService.isViewActive(this._code);

    if (!this._opposite) {
      return active;
    } else {
      return !active;
    }
  }

  private showElement(): void {
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }

  private hideElement(): void {
    this.viewContainer.clear();
    this.hasView = false;
  }
}
